import NotificationCard from "./NotificationCard";

export default function SurveyNotificationCard(props) {
    return (
        <NotificationCard
            {...props}
            type="survey"
            destination={"/surveys/r?key=" + props.notification.key}
        />
    );
}
